/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// @ts-nocheck
import { makeRequest } from "@/utils/axiosInterceptor";

async function getStudiesAnalytics(timeRange = '30') {
	try {
		const accessRoute = `/analytics/studies?timeRange=${timeRange}`
		const { data: studiesAnalytics } = await makeRequest("GET", accessRoute, "");
        console.log('Studies analytics:', studiesAnalytics)
		return studiesAnalytics;
	} catch (error) {
		console.error("Error fetching studies analytics:", error);
		// Return fallback data if API fails
		return {
			system: {
				totalHospitals: 0,
				totalStudies: 0,
				totalInstances: 0,
				totalStorageGB: 0,
			},
			hospitalMetrics: [],
			dailyUploads: [],
			modalityDistribution: {},
			uploadFrequency: {
				averagePerDay: 0,
				peakDay: 0,
				totalUploads: 0,
				recentUploads: 0,
			},
		};
	}
}
export default getStudiesAnalytics; 